import { IIconProps } from "../types"

export default function IconLL4(props: IIconProps) {
  const width = props.size || props.width || (94 / 5) * 3
  const height = props.size || props.height || (111 / 5) * 3
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 94 111"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M58.4117 2.36182C51.9638 0.392449 47.2953 -0.0474098 42.7267 1.00225C38.1482 2.06191 33.6796 4.6111 29.1111 7.20027C24.5426 9.78944 19.8641 12.4286 15.8554 15.0677C11.8366 17.6969 8.48772 20.3361 6.0485 22.5354C3.60928 24.7346 2.08977 26.4841 1.23004 29.6931C0.360321 32.902 0.160385 37.5605 0.920142 43.6686C1.6799 49.7766 3.40934 57.3242 6.19845 65.7615C8.99755 74.1988 12.8563 83.5158 16.2552 90.4536C19.6641 97.4014 22.6132 101.97 26.422 104.999C30.2307 108.028 34.8993 109.527 40.1876 109.617C45.4659 109.697 51.354 108.388 56.1324 106.279C60.9109 104.169 64.5697 101.27 68.0686 96.2517C71.5775 91.2433 74.9264 84.1256 78.5852 75.0785C82.2441 66.0314 86.2028 55.0449 88.842 46.8775C91.4811 38.7002 92.8007 33.3419 93.0106 28.9033C93.2106 24.4647 92.3008 20.9559 90.1615 18.1867C88.0322 15.4176 84.6833 13.3983 78.8851 10.6292C73.097 7.86005 64.8696 4.34118 58.4117 2.36182Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="0.899712"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
